import angular from 'angular';

import template from './templates/dropdown-directive.tpl.html';

import DropdownController from './dropdown-controller';

function dropdownDirective(dropdownTemplateService) {

  function validate(value, items, itemSet, textProperty, textPropertyFn, keyProperty) {

    if (!value) {
      return true;
    }

    if (angular.isDefined(keyProperty)) {
      return Object.keys(itemSet).some(key => value.toString() === key);
    }

    if (angular.isDefined(textProperty)) {
      return Array.isArray(items) &&
        items.some(item => textPropertyFn(value).toString() === textPropertyFn(item));
    }

    return Array.isArray(items) && items.some(item => value === item);
  }

  return {
    restrict: 'E',
    require: {
      ngModel: ''
    },
    scope: {},
    bindToController: {
      items: '=',
      textProperty: '@',
      keyProperty: '=?',
      placeholder: '@',
      itemFailureMessage: '@',
      noItemsMessage: '@',
      isDisabled: '=?',
      isReadonly: '=?',
      disabledProperty: '@?'
    },
    controller: DropdownController,
    controllerAs: 'dropdown',

    template(tElem) {
      return dropdownTemplateService.transformTemplate(tElem, template, 'akam-dropdown-selected',
        'akam-dropdown-option');
    },

    link(scope, elem, attrs, controllers) {
      const ngModel = controllers.ngModel;
      if (angular.isUndefined(scope.dropdown.items)) {
        scope.dropdown.items = [];
      }
      scope.dropdown.initialize();

      scope.$watch(() => scope.dropdown.getItems(), () => {
        ngModel.$validate();
      });

      ngModel.$validators.inList = (modelValue) => {
        return validate(modelValue, scope.dropdown.getItems(), scope.dropdown.itemSet,
          scope.dropdown.textProperty, scope.dropdown.textPropertyFn, scope.dropdown.keyProperty);
      };
    }

  };
}

dropdownDirective.$inject = ['dropdownTemplateService'];

export default dropdownDirective;
